
import { useEffect } from 'react';
import { fetchBootstrap } from '../api/bootstrap';
import * as SafeDom from '../utils/safeDom';   // ⬅️ namespace import

export default function AppInit() {
  useEffect(() => {
    // diag utile une seule fois en prod
    try { console.log('[APP] safeDom keys:', Object.keys(SafeDom)); } catch {}

    // appelle la fonction si elle existe
    SafeDom.ensurePortalRoot?.('cc-portal-root');
    
    let last = 0;
    
    async function revalidate() {
        const safeGet = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
        const token = safeGet('token');
        const userId = safeGet('userId');
      if (!token || !userId) return;
      try { 
        await fetchBootstrap(userId, token); 
      } catch (err) {
        console.log('Sync silencieuse échouée:', err.message);
      }
    }

    // Au chargement de la page (inclut "refresh")
    revalidate();

    // Quand l'onglet redevient actif (avec cooldown plus long)
    const onFocus = () => {
      const now = Date.now();
      if (now - last < 60000) return; // 1 minute de cooldown (SSE gère le temps réel)
      last = now;
      revalidate();
    };
    window.addEventListener('focus', onFocus);

    // Cross-tab storage bridge (cc:* → cc:cache-updated)
    const onStorage = (ev) => {
      if (!ev.key || typeof ev.key !== 'string') return;
      if (!ev.key.startsWith('cc:')) return;
      // topic = 'tasks/list' depuis 'cc:tasks/list'
      const topic = ev.key.slice('cc:'.length);
      window.dispatchEvent(new CustomEvent('cc:cache-updated', { detail: { topic, at: Date.now() } }));
    };
    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return null;
}